import $ from 'jquery'

$(document).on('turbo:load', onLoad)

function onLoad() {
  $("#billing-report-runs-form .select-all").click(function (event) {
    event.preventDefault();
    $('.protocol-checkbox').prop('checked', true);
    updateCounter();
    return false;
  });

  $("#billing-report-runs-form .clear-all").click(function (event) {
    event.preventDefault();
    $('.protocol-checkbox').prop('checked', false);
    updateCounter();
    return false;
  });

  $('.protocol-checkbox').change('checked', function () {
    updateCounter();
  });

  $("#billing-report-runs-form table tbody tr").css('cursor', 'pointer').click(function (event) {
    if (event.target.type !== 'checkbox' && event.target.tagName !== 'A') {
      const checkbox = $(this).find('.protocol-checkbox');
      checkbox.prop('checked', !checkbox.prop('checked'));
      updateCounter();
    }
  });

  updateCounter();
}

function updateCounter() {
  const count = $('.protocol-checkbox:checked').length;
  $('#selected-count').text(count + " Selected");
}
